import { z } from 'zod';

import { AuthorizedContactApi } from './AuthorizedContact';
import { BorrowerApi } from './Borrower';
import { EntityApi } from './Entity';

export const ContactsApi = z.object({
  borrowers: z.array(BorrowerApi),
  entity: EntityApi.optional(),
  authorizedContacts: z.array(AuthorizedContactApi),
});
export type ContactsApi = z.infer<typeof ContactsApi>;
